import React from 'react';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import {Table} from 'react-bootstrap';

import schedule from '../../assets/images/contents/ConferenceSchedule.docx';
import progBook from '../../assets/images/contents/SCDS2021-ProgramBook_Abstract.pdf';

export const ProgramBook = () => (
  <div>
  <Helmet>
    <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Program Book</title>
  </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item"><a href="/">Information</a></li>
        <li class="breadcrumb-item active" aria-current="page">Program Book</li>
      </ol>
    </nav>

    <h2>Program Book</h2><br/>

    <img src="https://chart.googleapis.com/chart?chs=150x150&amp;cht=qr&amp;chl=https://qrco.de/bcVNd6" alt="qrcode"/>

    <p>You can download program book by scanning the QR code above or just <a href={progBook} target="_blank" rel="noreferrer">click here.</a></p>

    <p><b>Day 1: 2 November 2021 (Tuesday)</b></p>

    <Table striped bordered hover>
      <thead>
      <tr> 
        <th>Time</th>
        <th>Activities</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>8:00 - 8:45 am IDT<br/>
            9:00 - 9:45 am MYT
        </td>
        <td>Online Registration</td>    
      </tr>

      <tr>
        <td>8.45 - 9.00 am IDT<br/>
            9:45 - 10:00 am MYT
        </td>
        <td><b>National anthems<br/>
            UiTM + ITS song</b>
        </td>
      </tr>

      <tr>
        <td>9:00 - 9:10 am IDT<br/>
            10:00 - 10:10 am MYT</td>
        <td><b>Welcome Speech<br/>
            Jerry Dwi Purnomo</b><br/>
            Conference Chair
        </td>    
      </tr>

      <tr>
        <td>9:10 - 9:20 am IDT<br/>
            10:10 - 10:20 am MYT</td>
        <td><b>Welcoming Remarks<br/>
            Prof. Dr. Mochamad Ashari, MEng</b><br/>
            Rector of ITS
        </td>
      </tr>

      <tr>
        <td>9:20 - 9:30 am IDT<br/>
            10:20 - 10:30 am MYT</td>
        <td><b>Opening Remarks<br/>
            Professor Ts Dr Roziah Binti Mohd Janor</b><br/>
            Vice-Chancellor of UiTM
        </td>
      </tr>

      <tr>
        <td>9:30 – 9:40 am IDT<br/>
            10:30 - 10:40 am MYT</td>
        <td>Online Exchange of Souvenirs between UiTM and ITS</td>
      </tr>

      <tr>
        <td>9.40 – 9.50 am IDT<br/>
            10:40 - 10:50 am MYT</td>
        <td>Montage SCDS 2021</td>
      </tr>

      <tr>
        <td>9:50 – 10:00 am<br/>
            10:50-11:00 am MYT</td>
        <td>Online Photography Session</td>
      </tr>

      <tr>
        <td>10:00 - 10:15 am IDT<br/>
            11:00 - 11:15 am MYT</td>
        <td>Break (play video)</td>
      </tr>

      <tr>
        <td>10:15 - 11:00 am IDT<br/>
            11:15 - 12:00 pm MYT</td>
        <td><b>Keynote Speech 1<br/><br/>
            YBhg Dato' Sri Dr Mohd Uzir Mahidin<br/>
            Chief Statistician, Department of Statistics, Malaysia</b><br/><br/>

            Title: Analytics and AI: Harnessing the Unconventional Data Sources<br/><br/>

            Moderator: Prof Dr Jasni Mohamad Zain, UiTM, Malaysia
        </td>
      </tr>

      <tr>
        <td>11:00 - 11:45 am IDT<br/>
            12:00 - 12:45 pm MYT</td>
        <td><b>Keynote Speech 2<br/><br/>
            Professor Dr. Guan-Hua, Huang<br/>
            National Yang Ming Chiao Tung University, Taiwan</b><br/><br/>

            Title: Machine Learning Classification of Functional Brain Imaging for Parkinson’s Disease Stage Prediction<br/><br/>

            Moderator: Jerry Dwi Trijoyo Purnomo, ITS, Indonesia
        </td>
      </tr>

      <tr>
        <td>11:45 - 12:45 pm IDT<br/>
            12:45 - 1:45 pm MYT</td>
        <td>Lunch Break</td>
      </tr>

      <tr>
        <td>12.45 - 1.30 pm IDT<br/>
            1:45 - 2:30 pm MYT</td>
        <td><b>Keynote Speech 3<br/><br/>
            Professor Dr.rer.pol Heri Kuswanto<br/>
            Institut Teknologi Sepuluh Nopember, Indonesia</b><br/>

            Title: Challenges in Weather and Climate Research: How can we benefit from open data source?<br/><br/>

            Moderator: Jerry Dwi Trijoyo Purnomo, ITS, Indonesia
        </td>
      </tr>
      
      <tr>
        <td>2:30 – 3:30 pm IDT<br/>
            2:30 - 4:30 pm MYT</td>
        <td>Paper presentations (Session 1)<br/>
            <b>Track 1: AI Techniques and Application<br/>
            Track 2: Data Analytics and Technology</b><br/><br/>

            Zoom (Breakout room)<br/><br/>

            Moderator:<br/>
            Track 1: Prof. Sri Hartati, UGM, Indonesia<br/>
            Track 2: Prof. Adel Al-Jumaily, CSU, Australia
        </td>
      </tr>

      <tr>
        <td>3:30 - 3:45 pm IDT<br/>
            4:30 - 4:45 pm MYT</td>
        <td>Break</td>
      </tr>
      
      <tr>
        <td>3:45 – 4:45 pm IDT<br/>
            4:45 - 5:45 pm MYT</td>
        <td>Paper presentations (Session 2)<br/>
            <b>Track 1: AI Techniques and Applications<br/>
            Track 2: Data Analytics and Technology</b><br/><br/>

            Zoom (Breakout room)<br/><br/>

            Moderator:<br/>
            Track 1: Prof. Dhiya Al-Jumeily, LJMU, UK<br/>
            Track 2: Dr. Azlan Ismail, UiTM, Malaysia
        </td>
      </tr>
    
    </tbody>
    </Table><br/>

    <p><b>Day 2: 3 November 2021 (Wednesday)</b></p>  

    <Table striped bordered hover>
      <thead>
      <tr> 
        <th>Time</th>
        <th>Activities</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>8:00 - 8:45 am IDT<br/>
            9:00 - 9:45 am MYT</td>
        <td>Online Registration</td>    
      </tr>

      <tr>
        <td>9:00 - 9:45 am IDT<br/>
            10:00 - 10:45 am MYT</td>
        <td><b>Keynote Speech 4<br/>
            Assistant Professor Dr. Ubydul Haque<br/>
            University of North Texas Health Science Center, USA</b><br/><br/>

            Title: Spatio-temporal Dynamics of Dengue, Chikungunya, and Zika Viruses in Mexico: A Potential Co-circulation Problem<br/><br/>

            Moderator: Dr. Achmad Choiruddin, ITS
        </td>
      </tr>

      <tr>
        <td>9:45 -10:30 am IDT<br/>
            10:45 - 11:30 am MYT</td>
        <td><b>Keynote Speech 5<br/>
            Associate Professor Dr Simon Fong<br/>
            University of Macau, China</b><br/>

            Title: XAI Early Cancer Detection Using Swarm Intelligence Marker-Based Watershed Segmentation Algorithm 
            and Evolving Graph Convolutional Network: Case of Lung Cancer Deep Analysis from Pulmonary Nodules and Cancer Images<br/><br/>

            Moderator: Dr.rer.pol Dedy Dwi Prastyo, ITS
        </td>
      </tr>

      <tr>
        <td>10:30 - 10:45 am IDT<br/>
            11:30 - 11:45 am MYT</td>
        <td>Break</td>
      </tr>

      <tr>
        <td>10:45 - 11:45 am IDT<br/>
            11:45 - 12:45 am MYT</td>
        <td>Paper presentations (Session 3)<br/>
            <b>Track 3: Data Mining and Image Processing<br/>
            Track 4: Machine and Statistical Learning </b><br/><br/>

            Zoom (Breakout room)<br/><br/>

            Moderator:<br/>
            Track 3: Dr. Ahmad Nazim Aimran, UiTM<br/>
            Track 4: Dr. Santi Wulan Purnami,  ITS
        </td>
      </tr>

      <tr>
        <td>11:45 - 12:45 pm IDT<br/>
            12:45 - 1:45 pm MYT</td>
        <td>Lunch Break</td>
      </tr>

      <tr>
        <td>12.45 - 1.30 pm IDT<br/>
            1:45 - 2:30 pm MYT</td>
        <td><b>Keynote Speech 6<br/>
            Professor Dr. Richard C Millham<br/>
            Durban University of Technology, South Africa</b><br/><br/>

            Title: Use of Bio-inspired Algorithms for Intelligent Energy Management of Renewable Energy Resources<br/><br/>

            Moderator: Dr. Irhamah, ITS
        </td>
      </tr>

      <tr>
        <td>1.30 - 2.15 pm IDT<br/>
            2:30 - 3:15 pm MYT</td>
        <td><b>Keynote Speech 7<br/>
            Associate Professor Dr. Aiden Doherty<br/>
            Oxford University, UK</b><br/><br/>

            Title: Reproducible Machine Learning of Movement Behaviours in 
            Terrabytes of Wearables Data<br/><br/>

            Moderator: Professor Dr Yap Bee Wah, UiTM
        </td>
      </tr>

      <tr>
        <td>2:15 - 4:30 pm IDT<br/>
            3:15 - 5:30 pm MYT
        </td>
        <td>Parallel Paper presentations (Session 4)<br/>
            <b>Track 5: Machine and Statistical Learning</b><br/><br/>

            Zoom (Breakout room)<br/>

            Moderator:<br/>
            Dr. Santi Wulan Purnami
        </td>
      </tr>

      <tr>
        <td>4:30 - 5:00 pm IDT<br/>
            5:30 - 6:00 pm MYT</td>
        <td>Best Paper Awards (10 papers)<br/>
            <b>Closing</b><br/>
            Professor Dr Yap Bee Wah
        </td>
      </tr>
    
    </tbody>
    </Table>      
   
    <p>
      Note: <br/>
      IDT: Indonesia time (GMT+7)<br/>
      MYT: Malaysia time (GMT+8)
    </p>

    <p>You also can download this conference schedule <a href={schedule} target="_blank" rel="noreferrer">here.</a></p>
  </div>
)